import { apiFetch } from "../api";

export const getDocuments = async () => {
  const response = await apiFetch("/documents");
  if (!response.ok) {
    throw new Error("Failed to fetch documents");
  }
  const data = await response.json();
  return { data };
};

export const getDocument = async (id) => {
  const response = await apiFetch(`/documents/${id}`);
  if (!response.ok) {
    throw new Error("Failed to fetch document");
  }
  const data = await response.json();
  return { data };
};

export const uploadDocument = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  const response = await apiFetch("/documents/upload", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Failed to upload document");
  }
  const data = await response.json();
  return { data };
};

export const updateDocument = async (id, data) => {
  const response = await apiFetch(`/documents/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Failed to update document");
  }
  const resData = await response.json();
  return { data: resData };
};

export const deleteDocument = async (id) => {
  const response = await apiFetch(`/documents/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Failed to delete document");
  }
  const data = await response.json();
  return { data };
};

export const getNotes = async () => {
  const response = await apiFetch("/notes");
  if (!response.ok) {
    throw new Error("Failed to fetch notes");
  }
  const data = await response.json();
  return { data };
};

  export const createNote = async (data) => {
    const response = await apiFetch("/notes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

  if (!response.ok) {
    throw new Error("Failed to create note");
  }
  const resData = await response.json();
  return { data: resData };
};

export const updateNote = async (id, data) => {
  const response = await apiFetch(`/notes/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("Failed to update note");
  }
  const resData = await response.json();
  return { data: resData };
};

export const deleteNote = async (id) => {
  const response = await apiFetch(`/notes/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Failed to delete note");
  }
  const data = await response.json();
  return { data };
};
